import type { IconData } from '@stacksjs/iconify-core'

export const otherUiAward: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m5 0l2.075 4.565A6.5 6.5 0 0 0 3.073 6.76L0 0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.73 6.007A4.997 4.997 0 0 0 3 11a5 5 0 1 0 9.22-2.683L16 0h-5L8.27 6.007a5 5 0 0 0-.54 0M9.25 11a1.25 1.25 0 1 1-2.5 0a1.25 1.25 0 0 1 2.5 0\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiAward
